/**
 * Scroll a specific chat message bubble into view.
 *
 * Pure/DOM-only helper so it can be unit tested without mounting the whole
 * ChatWindow. Looks up an element via `data-message-id` inside `container`
 * and scrolls it into view. No-ops (returns false, never throws) when the
 * container isn't ready or the message isn't present -- e.g. the id is
 * stale, missing, or the messages haven't loaded yet.
 */
export function scrollMessageIntoView(
  container: HTMLElement | null | undefined,
  messageId: string | null | undefined
): boolean {
  if (!container || !messageId) {
    return false;
  }

  const target = container.querySelector<HTMLElement>(
    `[data-message-id="${cssEscape(messageId)}"]`
  );

  if (!target) {
    return false;
  }

  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  return true;
}

function cssEscape(value: string): string {
  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
    return CSS.escape(value);
  }
  // Fallback for environments without CSS.escape (e.g. some test runners):
  // escape anything that isn't alphanumeric/underscore/hyphen.
  return value.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
}
